<div class="block-right">
    <div>
        <a (click)="goPageDetail('doiqua','')"> <img alt="" src="../../../assets/images/hopqua.png"></a>
    </div>
    <div *ngIf="external">
        <img class="clickvideo" (click)="actionOnClickHelp()" alt="" src="../../../assets/images/bong-den@3x.png">
    </div>
    <div *ngIf="external">
        <img class="clicksetting" (click)="actionOnSetting()" alt="" src="../../../assets/images/main/setting.png">
    </div>
</div>
<!--&lt;!&ndash; popup ma kick hoat &ndash;&gt;-->
<!--<div class="popup-wrap ma-kh">-->
<!--    <div class="popup-box" style="background: #F69696;">-->

<!--        <form style="margin-top: -20px">-->
<!--            <h2>{{ 'core.active.title' | translate }}</h2>-->
<!--            <div class="form-contr">-->

<!--                <input id="f012" type="text"/>-->

<!--            </div>-->

<!--            <div class="btn-popup" style=" margin-top: 15px;">-->
<!--                <button style="margin-right: 0" type=""> {{ 'core.active.send' | translate }}</button>-->

<!--            </div>-->
<!--        </form>-->
<!--        <a class="close-btn popup-close" href="#"><img src="../../../assets/images/close.png" alt=""></a>-->

<!--        <div class="nhap-makh"-->
<!--             style="position: absolute; width: 90%; bottom: 10px; display: flex; justify-content: space-between; color: #fff">-->
<!--            <a href="" title=""> {{ 'core.active.buy' | translate }}</a>-->
<!--            <a href="" title=""> {{ 'core.active.forget' | translate }}</a>-->

<!--        </div>-->
<!--    </div>-->
<!--</div>-->
<!--<div class="popup-wrap video-youtube" *ngIf="help">-->
<!--        <app-video-screen [src]="videoLink" [help]="help"></app-video-screen>-->
<!--        <div class="close-btn popup-close">-->
<!--            <img src="../../../assets/images/close.png" alt="" (click)="closeVideo()"></div>-->

<!--</div>-->
<div class="header-video-background" *ngIf="help"></div>
<div class="header-video-help" *ngIf="help">
    <app-video-screen [help]="help" [src]="videoLink"></app-video-screen>
</div>
<div class="close popup-close" (click)="closeVideo()" *ngIf="help">
    <img src="../../../assets/images/close.png" alt="">
</div>
<!--<div class="video" *ngIf="help">-->
<!--    <div class="close-button" (click)="closeVideo()">-->
<!--        <img src="../../../assets/images/close.png" alt="">-->
<!--    </div>-->
<!--    -->
<!--</div>-->
<!--popup phuhuynh-->
<div class="popup-wrap phu-huynh" *ngIf="parent">
    <div class="popup-box"
         style="width: 54vw; height: 32vw; display: flex; flex-direction: column; align-items: center; justify-content: center; padding: 1vw 0;">
        <div style="position: relative; width: 100%;">
            <h2 class="key-header" style="font-size: 2vw; margin: 0.4vw 0;">{{ 'core.parent' | translate }}</h2>
        </div>
        <div style="position: relative; width: 100%;">
            <h2 style="font-size: 2.2vw; margin: 0.4vw 0;">{{ keyGenNumber?.num1 }} + {{ keyGenNumber?.num2 }}
                = {{ keysToString() }}</h2>
            <div class="keynumber">
                <div class="button" (click)="keyLock(0)">0</div>
                <div class="button" (click)="keyLock(1)">1</div>
                <div class="button" (click)="keyLock(2)">2</div>
                <div class="button" (click)="keyLock(3)">3</div>
                <div class="button" (click)="keyLock(4)">4</div>
            </div>
            <div class="keynumber">
                <div class="button" (click)="keyLock(5)">5</div>
                <div class="button" (click)="keyLock(6)">6</div>
                <div class="button" (click)="keyLock(7)">7</div>
                <div class="button" (click)="keyLock(8)">8</div>
                <div class="button" (click)="keyLock(9)">9</div>
            </div>
        </div>
        <a class="close-btn popup-close" (click)="closeSetting()">
            <img src="../../../assets/images/close.png" alt=""></a>
    </div>
</div>

<!--<div class="swiper-width">-->
